import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';
import { lock, unlock } from 'tua-body-scroll-lock'
import focusLock from 'dom-focus-lock'

gsap.registerPlugin(Flip);

export default {
  init: function (app) {
    this.app = app;
    if (!customElements.get('welcome-screen')) {
      customElements.define('welcome-screen',
        class extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            const urlQuery = new URLSearchParams(document.location.search);
            if (urlQuery.get('mint-referral')) {
              document.querySelector('welcome-screen').remove();
            } else {
              this.init()
            }
          }
          init() {
            lock(this);
            focusLock.on(this);
            this.tiles = this.querySelectorAll('.tile');

            this.button = this.querySelector('.architecture .Button')
            this.button.addEventListener('click', (e) => {
              e.preventDefault();
              gsap.to(this, { opacity: 0, display: "none", duration: 2 })
              unlock(this);
              focusLock.off(this);
              setTimeout(() => {
                document.querySelector('welcome-screen').remove();
              }, 2000);

            })

            this.tiles.forEach(tile => {
              tile.tl = gsap.timeline({
                paused: true,
                onStart: () => {
                  gsap.to(tile.querySelector(".title2"), { opacity: 0 })
                },
                onComplete: () => {


                },
                onReverseComplete: () => {
                  gsap.to(tile.querySelector(".title2"), { opacity: 1 })
                }
              })

              const inner = tile.querySelector('.inner')
              const els = tile.querySelectorAll('.inner > *')

              tile.tl
                .fromTo(inner,
                  {
                    opacity: 0,
                    x: tile.classList.contains('architecture') ? "-50vw" : "50vw"
                  },
                  {
                    delay: 0.3,
                    duration: 0.5,
                    opacity: 1,
                    x: 0,
                  }
                )
                .fromTo(els,
                  { opacity: 0, x: tile.classList.contains('architecture') ? "-50vw" : "50vw" },
                  { delay: 0.5, duration: 0.5, stagger: { each: 0.15 }, opacity: 1, x: 0 })

              this.tiles[0].tl.progress(1)
              tile.addEventListener('click', event => this.toggle(tile))
              tile.addEventListener('focusin', event => this.toggle(tile))
            })
          }

          toggle(tile) {

            const state = Flip.getState('welcome-screen > *');

            const current = [...this.tiles].find(t => t != tile)

            current.classList.remove('active')
            tile.classList.add('active')

            Flip.from(state, {
              duration: 1,
              ease: "power3",
              delay: 0.5
            });
            tile.tl.play()
            current.tl.reverse()
          }
        }
      );
    }
  }
};
